import React from "react";
import {NavLink} from "react-router-dom";
import Slider from 'react-animated-slider';

import '../../../css/styles.css';

export default function Sliders(props) {

    return (
      <Slider className="slider-wrapper main-sliders slide" autoplay="3000" touchDisabled={true}>
  			{props.articles.slice(0, props.maximumSlidersCount).map((item, index) => (
  				<div
  					key={index}
  					className="slider-content"
  					style={{ background: `url('${item.sliderImage}') no-repeat center center` }}
  				>
  					<div className="inner">
  						<h1>{item.title}</h1>
  						<p>{item.sliderDescription}</p>
  					</div>

  				</div>
  			))}
  		</Slider>
    );

}
